import API_URLS from '../../config/apiConfig';
import type { Game } from '../../types/features/games';

const ABSOLUTE_URL_PATTERN = /^(?:https?:)?\/\//i;

export const normalizeGameImageUrl = (imageUrl: string | null | undefined): string => {
  if (!imageUrl) {
    return '';
  }

  if (
    ABSOLUTE_URL_PATTERN.test(imageUrl)
    || imageUrl.startsWith('blob:')
    || imageUrl.startsWith('data:')
  ) {
    return imageUrl;
  }

  const normalizedPath = imageUrl.replace(/^\/+/, '');
  const uploadPath = normalizedPath.startsWith('uploads/')
    ? `/${normalizedPath}`
    : `/uploads/${normalizedPath}`;

  return API_URLS.COMPLETE_GAME_IMAGE_URL(uploadPath);
};

export const getGameImageSource = (game: Pick<Game, 'image' | 'image_url'>): string =>
  normalizeGameImageUrl(game.image_url || game.image);
